import { render, staticRenderFns } from "./endPack.vue?vue&type=template&id=5f103e2a&scoped=true"
import script from "./endPack.vue?vue&type=script&lang=js"
export * from "./endPack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f103e2a",
  null
  
)

export default component.exports